module.exports = __webpack_public_path__ + "img/sh.d107b272.png";